import { MILESTONE_STATUSES, DELIVERY_STATUSES } from 'features/order-tracker/utils/entries';
import { MILESTONES_NAMES_MAPPER } from './helpers/constants';

export class TrackingEventsService {
  private readonly responses: common.DeliveryTrackingInfo[];

  public isTrackingEventsFailed: boolean;

  constructor(responses: common.DeliveryTrackingInfo[]) {
    this.responses = responses.filter(response => !!response);
    this.isTrackingEventsFailed = !!responses.length && responses.length !== this.responses.length;
  }

  getOrderStatusFromTrackingEvents = (): common.DeliveryStatus | string => {
    if (!this.responses.length || this.isTrackingEventsFailed) {
      return '';
    }

    const isDelivered = this.responses
      .every(response => response.status === DELIVERY_STATUSES.Delivered);

    return isDelivered ? DELIVERY_STATUSES.Delivered : DELIVERY_STATUSES.InProgress;
  };

  mapDeliveryMilestoneItems = (orderMilestones: common.OrderMilestone[]): common.OrderMilestone[] =>
    orderMilestones.map(milestone => {
      const {
        status,
        milestoneStatus,
        formattedDate,
        hasStatusLabel,
        delivery: {
          trackingReference,
        } = {},
      } = milestone;

      const trackingInfo = this.responses.find(response => response.trackingReference === trackingReference);

      const isDeliveredTrackingStatus = trackingInfo?.status === DELIVERY_STATUSES.Delivered;
      const updatedMilestoneStatus = isDeliveredTrackingStatus ? MILESTONE_STATUSES.complete : milestoneStatus;
      const updatedDeliveryStatus = isDeliveredTrackingStatus ? trackingInfo?.status : status;
      const updatedFormattedDate = isDeliveredTrackingStatus ? trackingInfo?.lastEventDateTime : formattedDate;
      const updatedHasStatusLabel = isDeliveredTrackingStatus ? false : hasStatusLabel;
      const displayTitle = MILESTONES_NAMES_MAPPER[milestone.title] || milestone.title;

      return {
        ...milestone,
        milestoneStatus: updatedMilestoneStatus,
        displayTitle,
        status: updatedDeliveryStatus,
        formattedDate: updatedFormattedDate,
        hasStatusLabel: updatedHasStatusLabel,
        delivery: {
          ...milestone.delivery,
          trackingInfo: trackingInfo || {},
        },
      } as common.OrderMilestone;
    });
}
